module.exports = __webpack_public_path__ + "291323b9435915c3c7a252db18235bee.png";